import {StyledDialogProps} from 'common/components/UpsellDialog/styled';
import sc from 'styled-components';

interface StyledResProps extends StyledDialogProps {
	$noPaddingHeader?: boolean;
	$noPadding?: boolean;
    $flexDirection?: 'column' | 'row';
	$width?: number;
}

export const StyledResDialogHeader = sc.div<StyledResProps>`
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: ${({$noPaddingHeader}) => $noPaddingHeader ? '0' : '16px 16px 0px 16px'};
`;

export const StyledResDialogContent = sc.div<StyledResProps>`
	display: flex;
	flex-direction: ${({$flexDirection}) => $flexDirection || 'column'};
	${({$width}) => $width !== undefined ? `width: ${$width}px;` : 'width: 100%;'}
	padding: ${({$noPadding}) => $noPadding ? '0' : '16px'};
`;